import { QueryConfig, QueryResult } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Barrio } from "@/shared/types/barrio";

export async function getBarrio(id:string): Promise<Barrio> {
    await sleep(1000);
    const response = await api.get("barrios/" + id);
    return response.data;
}

export function useGetBarrioQuery(id: string, queryConfig: QueryConfig<Barrio> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getBarrio(id),
        queryKey: ["barrios", id],
    });
}

export interface GetBarrioQueryProps {
    id: string;
    queryConfig?: QueryConfig<Barrio>;
    children?: (queryResult: QueryResult<Barrio>) => ReactNode;
}

export function GetBarrioQuery({
    id,
    queryConfig,
    children,
}: GetBarrioQueryProps) {
    const queryResult = useGetBarrioQuery(id, queryConfig);
    return children && children(queryResult);
}
    